import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';

export interface UserExtensionAccount {
  account_id: number;
  account_name: string | null;
}

export interface UserExtensionVersionRow {
  user_id: number;
  email: string;
  version: string | null;
  last_seen_at: string;
  accounts: UserExtensionAccount[];
}

export interface UserExtensionVersionsResponse {
  rows: UserExtensionVersionRow[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export const extensionVersionService = {
  async getVersions(params?: {
    page?: number;
    limit?: number;
    accountId?: number;
    version?: string;
  }): Promise<UserExtensionVersionsResponse> {
    const response = await api.get<ApiResponse<UserExtensionVersionsResponse>>(
      API_ENDPOINTS.EXTENSION_VERSION.VERSIONS,
      { params }
    );
    return response.data.data;
  },
};
